import { Box, BoxProps } from '@cdl/heartbeat-react';
import { PropsWithChildren } from 'react';

export const PlotContainer: React.FC<PropsWithChildren<BoxProps>> = ({
  children,
  ...boxProps
}) => {
  return (
    <Box
      borderRadius='4px'
      bgColor='neutral.0'
      pb='m'
      px='s'
      {...boxProps}
      shadow={400}
    >
      {children}
    </Box>
  );
};
